import _ from "lodash";
import { useSelector } from "react-redux";
import { Drink } from "../db";
import { DrinkCache } from "../slices/drinkCache";

export function getDrinkById(
  id: string | number,
  ownDrinks: Drink[],
  drinkCache: DrinkCache
): Drink | undefined {
  if (_.isString(id)) {
    return ownDrinks.find((drink) => drink.id === id);
  }

  return drinkCache.drinks.map((d) => d.drink).find((drink) => drink.id === id);
}

export default function useGetDrinkById(
  id: string | number
): Drink | undefined {
  const ownDrinks: Drink[] = useSelector((state: any) => state.ownItems.Drinks);
  const drinkCache: DrinkCache = useSelector((state: any) => state.drinkCache);

  return getDrinkById(id, ownDrinks, drinkCache);
}

export function useGetDrinkBySelection(selection): Drink | undefined {
  const drink = useGetDrinkById(selection.drinkId);

  return drink;
}
